import { ProductCodeRange } from './LeadProducts';
import { StepProgress } from './StepProgress';

export class FlowSteps {
  flowId: ProductCodeRange;
  stepProgresses: StepProgress[];
  constructor(flowId: number, stepProgresses: StepProgress[]) {
    this.flowId = flowId;
    this.stepProgresses = stepProgresses;
  }
}
